import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { EPInput } from '@/comp';
import IconSearch from '@/assets/icon-search.svg?react';

const EPInputSearch = ({
  onChange,
  value,
  ...props
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  [x: string]: unknown;
}) => {
  const [_value, set_Value] = useState('');

  const onChangeInput = e => {
    set_Value(e.target.value);
    onChange && onChange(e);
  };

  useEffect(() => {
    set_Value(value);
  }, [value]);

  return (
    <StyledEPInput
      {...props}
      suffix={_value ? null : <IconSearch className={'icon-search'} />}
      {...{ allowClear: _value ? true : false }}
      value={_value}
      onChange={onChangeInput}
    />
  );
};

const StyledEPInput = styled(EPInput)`
  .ant-input-suffix {
    cursor: initial !important;

    .anticon-close-circle {
      padding: 0 ${({ theme: { token } }) => token.paddingXXS}px;
      margin-left: 0;

      svg {
        fill: ${({ theme: { token } }) => token.colorBorder};
      }
    }
  }
`;

export default EPInputSearch;
